import type { CXRootStore } from '../stores/cx-root.store';
import { ICXCompanyConfiguration } from '~/types/cx-types/cx-company-configuration.types';
import { calculateCXEnvironment } from '~/utils/cx-utils/cx-environment.utils';
import { CXEnvironments } from '~/types/cx-types/cx-environment.types';
import { getStagingApiBaseUrl } from '~/utils/cx-utils/cx-api.utils';

export class ConfigCXCtrl {
    rootStore: CXRootStore;

    constructor(rootStore: CXRootStore) {
        this.rootStore = rootStore;
    }

    async loadClientPortalConfiguration() {
        const { configService, clientPortalConfigStore } = this.rootStore;

        let clientPortalConfiguration: ICXCompanyConfiguration = null;
        let callCounter = 0;
        // TODO: limit loop
        while (!clientPortalConfiguration && callCounter < 3) {
            clientPortalConfiguration =
                // eslint-disable-next-line no-await-in-loop
                await configService.fetchClientPortalConfiguration(
                    clientPortalConfigStore.env
                );
            callCounter++;
            if (
                clientPortalConfiguration &&
                clientPortalConfiguration.redirect_to
            ) {
                clientPortalConfigStore.setClientPortalEnv(
                    calculateCXEnvironment(
                        clientPortalConfiguration.redirect_to.domain,
                        clientPortalConfiguration.redirect_to.prefix
                    )
                );
                clientPortalConfiguration = null;
            } else {
                if (
                    clientPortalConfigStore.env.environment ===
                    CXEnvironments.Staging
                ) {
                    clientPortalConfiguration = {
                        ...clientPortalConfiguration,
                        staging_api_base_url: getStagingApiBaseUrl()
                    };
                }

                clientPortalConfigStore.setClientPortalConfiguration(
                    clientPortalConfiguration
                );
            }
        }
    }

    async loadGon() {
        const { configService, configStore } = this.rootStore;
        const recaptcha = await this.loadActivateRecaptchaOnStaging();
        const gon = await configService.fetchGon();

        configStore.setConfig({ ...gon, ...recaptcha });
    }

    async loadActivateRecaptchaOnStaging() {
        const { searchParams } = new URL(window.location.href);
        return { activate_recaptcha: searchParams.has('acre') };
    }
}
